<template>
  <div class="alarm2-wrapper">
    <el-table
      :data="alarmList"
      stripe
      style="width: 100%"
      height="100%"
    >
      <template slot="empty">没有警情需要处理</template>

      <el-table-column
        prop="id"
        label="id"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="设备"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="typeStr"
        label="警情类型"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="value"
        label="报警值"
        width="80"
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="报警时间"
      >
      </el-table-column>
      <el-table-column
        prop="serial"
        v-if="1 ==0"
      >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="submitHandle(scope.row.serial)"
          >处理</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs'
var apiServer = "http://39.105.155.249:3000"
//var apiServer = "http://localhost:3000"
export default {
  data() {
    return {};
  },
  props: {
    alarmList: Array,
  },
  methods: {
    submitHandle(serial){
      let url = apiServer + '/handleAlarm';
      let data = {};
      data.account = localStorage.getItem("account");
      data.serial = serial;
      axios.post(url,qs.stringify(data)).then(r=>{
        if(r.data.code ==0){
          this.$emit('handelAlarmSucced',serial);
        }
      })
      .catch(e=>{
        console.log(e);
      })
    }
  },
};
</script>

<style lang="less">
.alarm2-wrapper {
  width: 90%;
  margin: 0 auto;
  height: calc(100vh - 70px);
}
</style>